console.log('Cart Popup JavaScript (Consolidated) loaded and executing!');

document.addEventListener('DOMContentLoaded', function() {
    function handleContinueShopping() {
        if (typeof $.magnificPopup !== 'undefined' && $.magnificPopup.instance.isOpen) {
            $.magnificPopup.close();
        } else {
            window.history.back();
        }
    }

    function handleViewShoppingCart(event) {
        event.preventDefault();
        window.location.href = '/cart';
    }

    document.addEventListener('click', function(event) {
        if (event.target.closest('#viewShoppingCartBtn') || event.target.closest('#viewShoppingCartBtnMobile')) {
            handleViewShoppingCart(event);
        } else if (event.target.closest('#continueShoppingBtn') || event.target.closest('#continueShoppingBtnMobile')) {
            handleContinueShopping();
        }
    });

    const checkoutBtn = document.getElementById('checkoutBtn');
    const agreeCheckboxDesktop = document.getElementById('product-cart__agree_desktop');
    const termsErrorMsgDesktop = document.getElementById('termsErrorMsgDesktop');

    const checkoutBtnMobile = document.getElementById('checkoutBtnMobile');
    const agreeCheckboxMobile = document.getElementById('product-cart__agree_mobile');
    const termsErrorMsgMobile = document.getElementById('termsErrorMsgMobile');

    function setupCheckoutButton(button, checkbox, errorSpan) {
        if (!button || !checkbox) return;

        if (!checkbox.checked) {
            button.classList.add('btn-disabled');
            button.setAttribute('aria-disabled', 'true');
        } else {
            button.classList.remove('btn-disabled');
            button.removeAttribute('aria-disabled');
        }

        checkbox.addEventListener('change', function() {
            if (this.checked) {
                button.classList.remove('btn-disabled');
                button.removeAttribute('aria-disabled');
                if (errorSpan) errorSpan.style.display = 'none';
            } else {
                button.classList.add('btn-disabled');
                button.setAttribute('aria-disabled', 'true');
            }
        });

        button.addEventListener('click', function(e) {
            if (!checkbox.checked) {
                e.preventDefault();
                const message = checkbox.getAttribute('data-message');
                if (errorSpan) {
                    errorSpan.textContent = message;
                    errorSpan.style.display = 'block';
                } else {
                    alert(message);
                }
                checkbox.focus();
                return;
            }
            window.location.href = '/checkouts';
        });
    }

    setupCheckoutButton(checkoutBtn, agreeCheckboxDesktop, termsErrorMsgDesktop);
    setupCheckoutButton(checkoutBtnMobile, agreeCheckboxMobile, termsErrorMsgMobile);

    document.addEventListener("keydown", function (e) {
        const mfpCloseBtn = document.querySelector('button.mfp-close');
        const cartPopupTotal = document.querySelector(".cart-popup-total");

        if (e.key === 'Tab' && e.shiftKey && cartPopupTotal && document.activeElement === cartPopupTotal) {
            e.preventDefault();
            if (mfpCloseBtn) {
                mfpCloseBtn.focus();
            }
        }
    });
});